// This file maps state to stores, and also exposes a fetchData function to fetch all
// the data needed to render the smart component
import CommonStore from '@src/stores/CommonStore';
import EntityStore from '@src/stores/EntityStore';

/**
 * These are the stores the container will subscribe to, the getStateFromStores()
 * below runs again if the stores mentioned here emit a change
 * @type {Array}
 */
export const listenToStores = [CommonStore, EntityStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    supportedLanguages: CommonStore.getSupportedLanguages(),
    entityData: EntityStore.getEntityData(),
    domain: CommonStore.getMetaTags().domain,
  };
}
